import { render, staticRenderFns } from "./SmsCode.vue?vue&type=template&id=60ad0862&"
import script from "./SmsCode.vue?vue&type=script&lang=ts&"
export * from "./SmsCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports